export default __webpack_public_path__ + "static/media/2824.62418283.png";